/**
 * POLYFILLS INTÉGRÉS POUR ESPACE PRO
 * Chargés directement dans app.js pour simplifier le déploiement
 */
(function() {
  'use strict';
  
  // Protection contre les multiples exécutions
  if (window.POLYFILLS_LOADED) return;
  window.POLYFILLS_LOADED = true;

  // POLYFILL 1: TextEncoder/TextDecoder pour les anciens navigateurs
  if (typeof TextEncoder === 'undefined') {
    window.TextEncoder = function TextEncoder() {
      this.encoding = 'utf-8';
    };
    window.TextEncoder.prototype.encode = function(str) {
      var utf8 = [];
      for (var i = 0; i < str.length; i++) {
        var charcode = str.charCodeAt(i);
        if (charcode < 0x80) utf8.push(charcode);
        else if (charcode < 0x800) {
          utf8.push(0xc0 | (charcode >> 6), 
                   0x80 | (charcode & 0x3f));
        }
        else if (charcode < 0xd800 || charcode >= 0xe000) {
          utf8.push(0xe0 | (charcode >> 12), 
                   0x80 | ((charcode>>6) & 0x3f), 
                   0x80 | (charcode & 0x3f));
        }
        else {
          i++;
          charcode = 0x10000 + (((charcode & 0x3ff)<<10) | (str.charCodeAt(i) & 0x3ff));
          utf8.push(0xf0 | (charcode >>18), 
                   0x80 | ((charcode>>12) & 0x3f), 
                   0x80 | ((charcode>>6) & 0x3f), 
                   0x80 | (charcode & 0x3f));
        }
      }
      return new Uint8Array(utf8);
    };
  }

  if (typeof TextDecoder === 'undefined') {
    window.TextDecoder = function TextDecoder() {
      this.encoding = 'utf-8';
    };
    window.TextDecoder.prototype.decode = function(bytes) {
      var result = '';
      var i = 0;
      while (i < bytes.length) {
        var byte1 = bytes[i++];
        if (byte1 < 0x80) {
          result += String.fromCharCode(byte1);
        } else if (byte1 < 0xc0) {
          // Invalid UTF-8
        } else if (byte1 < 0xe0) {
          var byte2 = bytes[i++];
          result += String.fromCharCode(((byte1 & 0x1f) << 6) | (byte2 & 0x3f));
        } else if (byte1 < 0xf0) {
          var byte2 = bytes[i++];
          var byte3 = bytes[i++];
          result += String.fromCharCode(((byte1 & 0x0f) << 12) | ((byte2 & 0x3f) << 6) | (byte3 & 0x3f));
        }
      }
      return result;
    };
  }

  // POLYFILL 2: Element.matches pour les anciens navigateurs
  if (!Element.prototype.matches) {
    Element.prototype.matches = 
      Element.prototype.matchesSelector || 
      Element.prototype.mozMatchesSelector ||
      Element.prototype.msMatchesSelector || 
      Element.prototype.oMatchesSelector || 
      Element.prototype.webkitMatchesSelector ||
      function(s) {
        var matches = (this.document || this.ownerDocument).querySelectorAll(s);
        var i = matches.length;
        while (--i >= 0 && matches.item(i) !== this) {}
        return i > -1;
      };
  }

  // POLYFILL 3: Element.closest pour les anciens navigateurs  
  if (!Element.prototype.closest) {
    Element.prototype.closest = function(s) {
      var el = this;
      do {
        if (Element.prototype.matches.call(el, s)) return el;
        el = el.parentElement || el.parentNode;
      } while (el !== null && el.nodeType === 1);
      return null;
    };
  }

  // POLYFILL 4: CustomEvent pour IE11
  if (typeof window.CustomEvent === 'undefined') {
    function CustomEvent(event, params) {
      params = params || { bubbles: false, cancelable: false, detail: undefined };
      var evt = document.createEvent('CustomEvent');
      evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
      return evt;
    }
    CustomEvent.prototype = window.Event.prototype;
    window.CustomEvent = CustomEvent;
  }

  // POLYFILL 5: Object.assign pour IE11
  if (typeof Object.assign !== 'function') {
    Object.assign = function(target) {
      'use strict';
      if (target == null) {
        throw new TypeError('Cannot convert undefined or null to object');
      }
      var to = Object(target);
      for (var index = 1; index < arguments.length; index++) {
        var nextSource = arguments[index];
        if (nextSource != null) {
          for (var nextKey in nextSource) {
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    };
  }

  // POLYFILL 6: Array.from pour IE11
  if (!Array.from) {
    Array.from = function(arrayLike, mapFn, thisArg) {
      var C = this;
      var items = Object(arrayLike);
      if (arrayLike == null) {
        throw new TypeError('Array.from requires an array-like object - not null or undefined');
      }
      var mapFunction = mapFn === undefined ? undefined : mapFn;
      if (typeof mapFunction !== 'undefined' && typeof mapFunction !== 'function') {
        throw new TypeError('Array.from: when provided, the second argument must be a function');
      }
      var len = parseInt(items.length);
      var A = typeof C === 'function' ? Object(new C(len)) : new Array(len);
      var k = 0;
      var kValue;
      while (k < len) {
        kValue = items[k];
        if (mapFunction) {
          A[k] = typeof thisArg === 'undefined' ? mapFunction(kValue, k) : mapFunction.call(thisArg, kValue, k);
        } else {
          A[k] = kValue;
        }
        k += 1;
      }
      A.length = len;
      return A;
    };
  }

  // POLYFILL 7: matchMedia pour les anciens navigateurs
  if (typeof window.matchMedia === 'undefined') {
    window.matchMedia = function(query) {
      return {
        matches: false,
        media: query,
        addListener: function() {},
        removeListener: function() {}
      };
    };
  }

  // POLYFILL 8: classList pour IE9/IE10
  if (!('classList' in document.documentElement)) {
    Object.defineProperty(HTMLElement.prototype, 'classList', {
      get: function() {
        var self = this;
        function update(fn) {
          return function(value) {
            var classes = self.className.split(/\s+/);
            var index = classes.indexOf(value);
            fn(classes, index, value);
            self.className = classes.join(' ');
          };
        }
        var ret = {
          add: update(function(classes, index, value) {
            if (!~index) classes.push(value);
          }),
          remove: update(function(classes, index) {
            if (~index) classes.splice(index, 1);
          }),
          toggle: update(function(classes, index, value) {
            if (~index)
              classes.splice(index, 1);
            else
              classes.push(value);
          }),
          contains: function(value) {
            return !!~self.className.split(/\s+/).indexOf(value);
          },
          item: function(i) {
            return self.className.split(/\s+/)[i] || null;
          }
        };
        Object.defineProperty(ret, 'length', {
          get: function() {
            return self.className.split(/\s+/).length;
          }
        });
        return ret;
      }
    });
  }

  console.log('Polyfills chargés avec succès dans app.js');
})();

import MatchMedia from './utils/matchMedia';
import SkipLink from './components/skip-link';
import ToggleMenuDesktop from './components/toggle-nav';
import ToggleMenuMobile from './components/toggle-nav-mobile';
import Toggle from './components/toggle';
import Breadcrumb from './components/breadcrumb';
import CookiesPopin from './components/cookies-popin';
import DialogPopin from './components/dialog';
import TitleAnimateTxt from './components/title-animate-txt';
import CarouselPartner from './components/carousel-partner';
import FilterMobile from './components/filter-mobile';
import './components/reveal';
// Van11y will be imported and initialized after DOM is ready
import { dataLayerGAWrapper } from './utils/taggingPlan';

// Make dataLayerGAWrapper available globally for HTML onclick handlers
window.dataLayerGAWrapper = dataLayerGAWrapper;

export function getHost() {
  switch (window.location.host) {
    case 'www.pro.sofinco.fr':
      return 'sofinco_professionnel';
    case 'rct.pro.sofinco.fr':
      return 'sofinco_professionnel_preprod';
    default:
      return 'sofinco_professionnel_local';
  }
}

class App {
    constructor() {
        window.components = {};
        window.components.app = this;

        this.matchMedia = new MatchMedia();
        this.ui = this.getUI();

        this.init();
        this.init_components();
        this.listen();
        this._resize();
        this._scroll();
    }

    getUI() {
        return {
            html: document.querySelector("html"),
            body: document.querySelector("body"),
            wrapper: document.querySelector("#wrapper"),
            page: document.querySelector("#main"),
            toggleMenuDesktop: document.querySelector(".js-toggle-menu-desktop"),
            headerDesktop: document.querySelector("#header .desktop"),
            toggleMenuMobile: document.querySelector("#header .header-mobile"),
            closeMenuMobile: document.querySelector("#navigationMobile__close"),
            headerMobile: document.querySelector(".header-mobile"),
            navMobile: document.querySelector(".header-mobile__nav"),
            toggle: document.querySelector(".js-toggle-block"),
            breadcrumb: document.querySelector('.breadcrumb'),
            cookiesBtn: document.getElementById("cookies-btn"),
            skipLink: document.getElementById("skiplink"),
            dialogBtn:  document.querySelector(".js-modal-button"),
            titleAnimate: document.querySelector(".animate-title__content"),
            partnerCarouselBtn: document.querySelector(".partner-carousel__rotation"),
            filterMobileBtn: document.getElementById("actualities-filters-btn")
        };
    }

    listen() {
        window.addEventListener("scroll", () => {
            this._scroll();
        });

        window.addEventListener("resize", () => {
            this._resize();
        });
    }

    init() {
        document.body.className = document.body.className.replace("no-js","js-ready");
        var lazyLoadInstance = new LazyLoad({}); // Instance lazy load
        // Tag de page : poussé par chaque page depuis assets/js/pages/*.js (plan de taggage V1.5, §4)
    }

    init_components() {
        if(this.ui.skipLink) {
            this.skipLink = new SkipLink();
        }

        if(this.ui.toggleMenuDesktop) {
            this.toggleMenu = new ToggleMenuDesktop();
        }

        if(this.ui.toggleMenuMobile) {
            this.toggleMenuMobile = new ToggleMenuMobile();
        }

        if(this.ui.toggle) {
            this.toggle = new Toggle();
        }

        if(this.ui.breadcrumb) {
            this.breadcrumb = new Breadcrumb();
        }

        if(this.ui.cookiesBtn) {
            this.cookiesPopin = new CookiesPopin();
        }

        if(this.ui.dialogBtn) {
            this.dialogPopin = new DialogPopin();
        }

        if(this.ui.titleAnimate) {
            this.titleAnimate = new TitleAnimateTxt();
        }

        if(this.ui.partnerCarouselBtn) {
            this.partnerCarousel = new CarouselPartner();
        }

        if(this.ui.filterMobileBtn) {
            this.ui.filterMobileBtn = new FilterMobile();
        }
        this.init_contact_buttons_tracking();
        
        // Initialize custom tabs functionality
        this.initCustomTabs();
    }

    _scroll() {
        let window_scroll = window.scrollY;
        
        if (this.matchMedia.isMobile || this.matchMedia.isTablet) {
            if(window_scroll > 79) {
                if(this.ui.headerMobile) {
                    this.ui.body.classList.add('header-sticky');
                    this.ui.wrapper.style.paddingTop = (this.ui.headerMobile.scrollHeight / 16)  + 'rem';
                }
            } else {
                this.ui.body.classList.remove('header-sticky');
                this.ui.wrapper.style.padding = '0';
            }
        }
        else {
            if(window_scroll > 121) {
                if(this.ui.headerDesktop) {
                    this.ui.body.classList.add('header-sticky');
                    this.ui.wrapper.style.paddingTop = (this.ui.headerDesktop.scrollHeight / 16)  + 'rem';
                }
            }
            else {
                this.ui.body.classList.remove('header-sticky');
                this.ui.wrapper.style.padding = '0';
            }
        }
    }

    _resize() {
        if(this.ui.navMobile) {
            if(this.ui.navMobile.style.display === 'block') { // Fermeture du menu mobile
                this.ui.closeMenuMobile.click();
            }
        }

        if(this.matchMedia.isMobile) { // En version mobile
            // Pour les toggles liens du footer
            const footerbottomlistbtnmobile = document.querySelectorAll(".footer-bottom__list-title.mobile.js-toggle-block__btn");
            footerbottomlistbtnmobile.forEach((item) => { // Pour chaque toggle
                // Vérification sécurisée des attributs
                const nextSibling = item.nextElementSibling;
                if(nextSibling && !nextSibling.hasAttribute("aria-labelledby")) {
                    const arialabelledbyid = item.getAttribute("id");
                    if(arialabelledbyid) {
                        nextSibling.setAttribute("aria-labelledby", arialabelledbyid);
                    }
                }
            });
        } else { // En version desktop
            // Pour les contenus liens du footer
            const footerbottomlisttext = document.querySelectorAll(".footer-bottom__list-inner");
            footerbottomlisttext.forEach((item) => { // Pour chaque contenu
                // Vérification sécurisée des attributs
                if(item.hasAttribute("aria-labelledby")) {
                    item.removeAttribute("aria-labelledby");
                }
            });
        }
    }

    init_contact_buttons_tracking() {
        const contactButtons = document.querySelectorAll('.btn-primary');

        contactButtons.forEach(button => {
            // Plan de taggage V1.5 - §5.8 : bouton "Demander une démo" (ancien nom : "Nous contacter")
            if (button.textContent.includes('Nous contacter') || button.textContent.includes('Demander une démo')) {
                button.addEventListener('click', () => {
                    if (window.EA_push) {
                        window.EA_push([
                            "rtgsite",
                            "professionnel",
                            "rtgpagename",
                            document.title,
                            "path",
                            window.location.pathname,
                            "from",
                            getHost(),
                            "rtgclickid",
                            "nous contacter"
                        ]);
                    }
                });
            }
        });
    }

    initCustomTabs() {
        // Find all tab containers on the page
        const tabContainers = document.querySelectorAll('.js-tabs');
        
        tabContainers.forEach(container => {
            const tabItems = container.querySelectorAll('.js-tablist__item');
            const tabContents = container.querySelectorAll('.js-tabcontent');
            
            if (tabItems.length > 0 && tabContents.length > 0) {
                // Initialize tabs for this container
                this.setupTabsForContainer(container, tabItems, tabContents);
            }
        });
    }

    setupTabsForContainer(container, tabItems, tabContents) {
        // Hide all tab contents initially except the first one
        tabContents.forEach((content, index) => {
            if (index === 0) {
                content.style.display = 'block';
                content.setAttribute('aria-hidden', 'false');
            } else {
                content.style.display = 'none';
                content.setAttribute('aria-hidden', 'true');
            }
        });

        // Set initial active state for first tab
        tabItems.forEach((item, index) => {
            const link = item.querySelector('.js-tablist__link');
            if (index === 0) {
                item.classList.add('active');
                link.setAttribute('aria-selected', 'true');
            } else {
                item.classList.remove('active');
                link.setAttribute('aria-selected', 'false');
            }
        });

        // Add click event listeners to tab items
        tabItems.forEach((item, index) => {
            const link = item.querySelector('.js-tablist__link');
            
            if (link) {
                link.addEventListener('click', (event) => {
                    event.preventDefault();
                    
                    // Remove active class from all tabs
                    tabItems.forEach(tabItem => {
                        tabItem.classList.remove('active');
                        const tabLink = tabItem.querySelector('.js-tablist__link');
                        if (tabLink) {
                            tabLink.setAttribute('aria-selected', 'false');
                        }
                    });
                    
                    // Hide all tab contents
                    tabContents.forEach(content => {
                        content.style.display = 'none';
                        content.setAttribute('aria-hidden', 'true');
                    });
                    
                    // Activate clicked tab
                    item.classList.add('active');
                    link.setAttribute('aria-selected', 'true');
                    
                    // Show corresponding content
                    if (tabContents[index]) {
                        tabContents[index].style.display = 'block';
                        tabContents[index].setAttribute('aria-hidden', 'false');
                    }
                    
                });
            }
        });
    }
}

document.addEventListener(
    "DOMContentLoaded",
    () => {
        // Plan de taggage V1.5 - §4 Recette : une seule instance d'App par page,
        // sinon les écouteurs du tag de clic sont posés deux fois ("se déclenche 2 fois").
        if (window.components && window.components.app) return;
        const app = new App();
    },
    false
);